import { h } from 'preact'
import '../UploadDocument/upload-document-styles.scss'
import { strHash } from '../../../_common/common'
import {deleteDocument, downloadFileFtp, saveDocument} from '../../../_rx/fct/actions'
import { toastService } from '../../../_services/toast-service'
import { t } from '../../../_i18n'
import { FILE_ACCEPT_FILES } from '../../constants'
import {useState} from "preact/hooks";

export default function UploadDocumentTimeline ({ name, label,className, input, typeDocument = 'attachment' , contractId, meta, disabled }) {
  const id = strHash(name+label);
    const showError = input.value.error_msg
        ? input.value.error_msg
        : (meta.invalid && meta.submitFailed)
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const FILE_SIZE_MAX = 5 * 1024 * 1024; // 5MB


    const handleChange = (val) => {
        const files = Array.from(val.target.files);
        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            if (file.size <= FILE_SIZE_MAX) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });
        if (invalidFiles.length > 0) {
            toastService.showToast({
                message: 'El archivo supera el tamaño máximo permitido (5MB).',
                type: 'danger'
            });
        }
        if (validFiles.length === 0) return;

        Promise.all(
            validFiles.map(file =>
                saveDocument(contractId, file, typeDocument)
            )
        )
            .then(res => {
                setUploadedFiles(prevFiles => {
                    const nextFiles = [...prevFiles, ...res];
                    input.onChange(nextFiles);
                    return nextFiles;
                });
            })
            .catch((error) => {
                const mensaje = error?.body?.message || '';
                if (mensaje.toLowerCase().includes('pdf')) {
                    toastService.showToast({
                        message: 'Los archivos deben ser obligatoriamente de tipo PDF.',
                        type: 'danger'
                    });
                } else {
                    toastService.showToast({
                        message: 'Ha sucedido un error con la subida del archivo, prueba de nuevo.',
                        type: 'danger'
                    });
                }
            });
  }

  const handleRemove = (fileId) => {
      deleteDocument(fileId)
      .then(() => {
          setUploadedFiles(prevFiles => {
              const nextFiles = prevFiles.filter(file => file.id !== fileId);
              input.onChange(nextFiles);
              return nextFiles;
          });
      })
      .catch(() => {
          toastService.showToast({
              message: 'Error al eliminar el documento.',
              type: 'danger'
          });
      });
  }

  return (
      <div className={`fct-upload-document ${className}`}>
          {uploadedFiles.map(file => (
              <div className='fct-upload-document__value m-bottom-half'>
                  <div className='font-bold t-underline'>
                      <i className="fas fa-paperclip m-r-half"></i>
                      <span className='cursor-pointer'
                            onClick={() => downloadFileFtp(file.id, file.file_name)}>{file.file_name}</span>
                  </div>
                  <div className='font-bold t-underline cursor-pointer font-color-149BAB m-l'
                       onClick={() => handleRemove(file.id)}>{t('Eliminar')}</div>
              </div>
          ))}
          <label className={`btn btn-ghost width-fit-content m-x2-bottom ${disabled ? 'btn-disabled' : ''}`} htmlFor={!disabled ? id : undefined}>
              <i className="fas fa-paperclip m-r-half m-top"></i>
              {t('Adjuntar archivo')}
          </label>
          <input type="file" id={id} onChange={handleChange} accept={FILE_ACCEPT_FILES} multiple value=''/>
      </div>
  )
}
